import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Paper,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import "react-datetime/css/react-datetime.css";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import InputFormat from "../../../partials/inputForm";
import SelectDateTime from "../../../partials/selectDateTime";
import { getNumberOnString } from "../../../partials/validateNumber";
import { isJsonString } from "../../../utils/setting";
import Dialog from "../../dialog";
import { toLocalTime, toUTC } from "../../formatUTC";
import Loading from "../../loading";
import NumberFormatCustom from "../../numberFormat";
import SelectedBranch from "../../selectedBranch";
import Snackbar from "../../snackbar";
import { styles } from "./styles";

const type = [
  {
    value: "value",
    label: "Value",
  },
  {
    value: "percent",
    label: "Percent",
  },
];

class AddDiscount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "id",
      data: [],
      page: 0,
      rowsPerPage: 5,
      voucher: [],
      dialog: {
        messageConfirm: "",
        content: "",
      },
      edit: {
        row: null,
      },
      editDiscount: {
        type: "percent",
        value: 0,
        start: new Date().getTime(),
        end: new Date().getTime(),
        note: "",
        branch: [],
        canUseVoucher: 0,
        enable: 0,
        forAll: 0,
      },
      isDisabledSelectedBranch: true,
    };
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDialog = this.handleDialog.bind(this);
  }
  componentDidMount() {
    this.getListDiscount();
  }
  getListDiscount = async () => {
    let { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.serviceDispatch.getListDiscount();
    this.loading.stopLoading();
    if (check.code === 1 && check.data) {
      let discount = isJsonString(check.data) ? JSON.parse(check.data) : {};
      if (discount.branch && discount.branch !== []) {
        discount.branch = isJsonString(discount.branch)
          ? JSON.parse(discount.branch)
          : [];
      }
      if (discount.type == "percent") discount.value *= 100;
      this.setState({ editDiscount: discount });
    } else if (check.code !== 1) {
      this.mSnackbar.handleClick(t(check.message), "error");
    }
  };
  handleDialog(notice) {
    let { t } = this.props;
    if (notice === t("discount_listdiscount_update")) {
      this.mDialog.handleDialogOpen();
    }
  }
  handleOpenDialog = (title, dataEdit) => {
    let { t } = this.props;
    if (title === "update") {
      let { editDiscount } = this.state;
      editDiscount.value = Number(editDiscount.value);
      if (
        editDiscount.type === "percent" &&
        (editDiscount.value > 100 || editDiscount.value <= 0)
      ) {
        this.mSnackbar.handleClick(
          t(
            "discount_listdiscount_please_enter_discount_less_than_or_equal_to_100_for_percent"
          ),
          "warning"
        );
      } else if (
        editDiscount.branch &&
        !editDiscount.branch.length &&
        editDiscount.forAll == 0
      ) {
        this.mSnackbar.handleClick(
          t(
            "discount_add_discount_please_choose_at_least_one_branch_to_apply_for_promotion"
          ),
          "warning"
        );
      } else if (editDiscount.endEdit - editDiscount.startEdit < 0) {
        this.mSnackbar.handleClick(
          t("discount_listdiscount_end_date_have_to_more_than_start_date"),
          "warning"
        );
      } else {
        this.setState(
          {
            dialog: {
              content: t(
                "discount_listdiscount_do_you_want_to_update_discount"
              ),
              title: t("discount_listdiscount_notice"),
              messageConfirm: t("discount_listdiscount_update"),
            },
          },
          function () {
            this.mDialog.handleDialogOpen();
          }
        );
      }
    } else if (title === "delete") {
      this.setState(
        {
          dialog: {
            content: t("discount_listdiscount_do_you_want_to_delete_discount"),
            title: t("discount_listdiscount_notice"),
            messageConfirm: t("discount_listdiscount_delete"),
          },
        },
        function () {
          this.mDialog.handleDialogOpen();
        }
      );
    }
  };
  actionDialog = () => {
    let { editDiscount } = this.state;
    let { t } = this.props;
    if (
      this.state.dialog.messageConfirm === t("discount_listdiscount_update")
    ) {
      this.handleUpdate(editDiscount);
    }
    if (
      this.state.dialog.messageConfirm === t("discount_listdiscount_delete")
    ) {
      this.handleUpdate();
    }
  };
  getFormattedDate = (date) => {
    return toLocalTime(date);
  };
  handleChangeValue = (event) => {
    let { editDiscount } = this.state;
    let value = event.target.value;
    let name = event.target.name;
    if (event.target.type === "checkbox") {
      value = event.target.checked ? 1 : 0;
    } else if (event.target.name === "value") {
      name = "value";
      value = getNumberOnString(value);
    }
    editDiscount[name] = value;
    this.setState({ editDiscount });
  };
  handleChangeDate = (name, date) => {
    let { editDiscount } = this.state;
    let milisecondInLocal =
      date && date._isAMomentObject ? date.valueOf() : moment().valueOf();
    editDiscount[name] = milisecondInLocal;
    if (name === "start" && editDiscount.end < editDiscount.start)
      editDiscount.start = editDiscount.end;
    else if (name === "end" && editDiscount.start > editDiscount.end)
      editDiscount.end = editDiscount.start;
    this.setState({
      editDiscount,
    });
  };
  handleChangeBranch = (value) => {
    let { editDiscount } = this.state;
    editDiscount.branch = value;
    this.setState({ editDiscount });
  };
  async handleUpdate(dataDiscount) {
    let { t } = this.props;
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    if (dataDiscount) {
      dataDiscount.start = toUTC(dataDiscount.start);
      dataDiscount.end = toUTC(dataDiscount.end);
      dataDiscount.value =
        dataDiscount.type == "percent"
          ? (dataDiscount.value /= 100)
          : dataDiscount.value;
    }
    let check = await this.props.serviceDispatch.updateDiscount(dataDiscount);
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("discount_listdiscount_update_successfully")
      );
      this.setState({
        isDisabledSelectedBranch: true,
      });
    } else {
      this.mSnackbar.handleClick(
        t("discount_listdiscount_update_unsuccessfully") + " " + check.message,
        "error"
      );
    }
    dataDiscount ? this.getListDiscount() : this.reset();
  }
  reset() {
    this.setState({
      editDiscount: {
        type: "percent",
        value: 0,
        start: new Date().getTime(),
        end: new Date().getTime(),
        note: "",
        branch: [],
        canUseVoucher: 0,
        enable: 0,
      },
    });
  }
  render() {
    const { classes, t } = this.props;
    let { editDiscount } = this.state;
    if (editDiscount) {
      return (
        <Paper className={classes.root}>
          <Loading onRef={(id) => (this.loading = id)} />
          <Dialog
            onRef={(dialog) => (this.mDialog = dialog)}
            disagree={t("discount_listdiscount_cancel")}
            agree={this.state.dialog.messageConfirm}
            content={this.state.dialog.content}
            title={this.state.dialog.title}
            action={this.actionDialog}
          />
          <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />

          <form className={classes.container} noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={3}>
                <InputFormat
                  required
                  label={t("discount_listdiscount_value")}
                  margin="normal"
                  value={editDiscount.value}
                  name="value"
                  onChange={this.handleChangeValue}
                  className={classes.textField}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: (
                      <InputAdornment position="end">
                        {editDiscount.type === "percent"
                          ? "%"
                          : this.props.currencyCode}
                      </InputAdornment>
                    ),
                    classes: {
                      inputType: classes.inputType,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <InputFormat
                  required
                  select
                  label={t("discount_listdiscount_type")}
                  name="type"
                  margin="normal"
                  fullWidth
                  value={editDiscount.type}
                  onChange={this.handleChangeValue}
                  className={classes.textField}
                  InputProps={{
                    fullWidth: true,
                    className: classes.input,
                  }}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                >
                  {type.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.value === "value"
                        ? this.props.currencyCode
                        : t(option.value)}
                    </MenuItem>
                  ))}
                </InputFormat>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <SelectDateTime
                  label={t("discount_listdiscount_start_date")}
                  required
                  margin="normal"
                  fullWidth
                  InputProps={{
                    className: classes.input,
                  }}
                  timeFormat="hh:mm A"
                  dateFormat="DD/MM/YYYY"
                  onChange={(date) => this.handleChangeDate("start", date)}
                  value={editDiscount.start}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <SelectDateTime
                  label={t("discount_listdiscount_end_date")}
                  required
                  margin="normal"
                  fullWidth
                  InputProps={{
                    className: classes.input,
                  }}
                  timeFormat="hh:mm A"
                  dateFormat="DD/MM/YYYY"
                  value={editDiscount.end}
                  onChange={(date) => this.handleChangeDate("end", date)}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <InputFormat
                  label={t("discount_listdiscount_note")}
                  name="note"
                  margin="normal"
                  value={editDiscount.note}
                  onChange={this.handleChangeValue}
                  className={classes.textField}
                  InputProps={{
                    className: classes.input,
                  }}
                  InputLabelProps={{
                    className: classes.label,
                  }}
                  multiline={true}
                  rows={3}
                  rowsMax={3}
                />
              </Grid>
              {!editDiscount.forAll ? (
                <Grid item xs={12} sm={12}>
                  <SelectedBranch
                    onRef={(id) => (this.SelectedBranch = id)}
                    multiple={true}
                    required={true}
                    disabled={editDiscount.forAll == 1}
                    handleChangeBranch={this.handleChangeBranch}
                    value={editDiscount.branch}
                  />
                </Grid>
              ) : (
                ""
              )}
              <Grid item xs={4} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={editDiscount.forAll == 1 ? true : false}
                      name="forAll"
                      onChange={this.handleChangeValue}
                    />
                  }
                  className={classes.label}
                  label={t("discount_listdiscount_all_branch")}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={editDiscount.canUseVoucher ? true : false}
                      name="canUseVoucher"
                      onChange={this.handleChangeValue}
                      // value= {this.state.canUseVoucher}
                    />
                  }
                  className={classes.label}
                  label={t(
                    "discount_listdiscount_can_be_used_with_voucher_code"
                  )}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={editDiscount.enable ? true : false}
                      name="enable"
                      onChange={this.handleChangeValue}
                      // value= {this.state.canUseVoucher}
                    />
                  }
                  className={classes.label}
                  label={t("discount_listdiscount_enable")}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={0}
              style={{ marginTop: 16 }}
              justify="flex-end"
            >
              <Button
                color="secondary"
                style={{ marginRight: "1rem" }}
                variant="contained"
                onClick={() => this.handleOpenDialog("delete")}
                className={classes.button}
              >
                {t("discount_listdiscount_delete")}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handleOpenDialog("update")}
                className={classes.button}
              >
                {t("discount_listdiscount_update")}
              </Button>
            </Grid>
          </form>
        </Paper>
      );
    } else {
      return <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />;
    }
  }
}

AddDiscount.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
});

const mapDispatch = (dispatch) => ({
  serviceDispatch: dispatch.service,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(AddDiscount)
  )
);
